/** Vercel custom env staging (`EXPO_PUBLIC_VUELTO_DEPLOY_ENV=pilot`). */
export const PILOT_DEPLOY_ENV = 'pilot';

export function isPilotDeployEnvironment(): boolean {
  return process.env.EXPO_PUBLIC_VUELTO_DEPLOY_ENV === PILOT_DEPLOY_ENV;
}
